import { PAGE_TITLE as FOUND_IN_DOCUMENTS } from './foundInDocuments.ts';
import type { Toolbar } from './api/navigation.ts';

export interface ModuleTab { label: string; to: string; exact: boolean }

/**
 * The tabs inside a module, under the toolbar, where a module has more than one page (moved out of
 * components/Toolbar.tsx unchanged, W1, so a test reads them). Legal gains "Found in the documents" (176) exactly when
 * the server says the reader may open it (`found_in_documents`, from the page's own gate); its path is App.tsx's route.
 */
export function subTabs(module: string, t: Pick<Toolbar, 'kind_review' | 'may_add_client' | 'found_in_documents'>): ModuleTab[] {
  switch (module) {
    case 'clients':
      return [
        { label: 'All clients', to: '/clients', exact: true },
        { label: 'Held at load', to: '/clients/held', exact: true },
        { label: 'Discharges to confirm', to: '/clients/discharge-confirmation', exact: true },
        ...(t.may_add_client ? [{ label: 'Add a client', to: '/clients/new', exact: true }] : []),
      ];
    case 'visits':
      return [
        { label: 'Visits due', to: '/visits', exact: true },
        { label: 'Board', to: '/visits/board', exact: true },
        { label: 'Facilities', to: '/facilities', exact: false },
      ];
    case 'legal':
      return [
        { label: 'Commissions', to: '/legal', exact: true },
        ...(t.kind_review ? [{ label: 'Appointments to check', to: '/legal/appointments', exact: true }] : []),
        ...(t.found_in_documents ? [{ label: FOUND_IN_DOCUMENTS, to: '/legal/found-in-documents', exact: true }] : []),
      ];
    default:
      return [];
  }
}
